import React from "react";
import { Chip, Tooltip, CircularProgress } from "@mui/material";
import LoopIcon from "@mui/icons-material/Loop";

import ZoomMeetingRecording from "../availability/ZoomMeetingRecording";

export default function HoverableZoomMeetingRecordingChip({ isZoomRecordingChipHoveredOver, setIsZoomRecordingChipHoveredOver, session, isDataLoading }) {
    const defaultOptions = {displayMeetingId: false};

    return (
      (!isZoomRecordingChipHoveredOver || isDataLoading)
        ? <Tooltip title={isDataLoading ? <CircularProgress size={20} sx={{color: 'white'}}/> : null}>
            <Chip icon={<LoopIcon />} size="small" sx={{backgroundColor: "rgba(255, 255, 255, 0.8)"}} onMouseEnter={() => setIsZoomRecordingChipHoveredOver(true)}/>
        </Tooltip>
        : <ZoomMeetingRecording recordingStatus={session?.lessonRecordingStatus} recordingUrls={session?.zoomMeetingRecordingUrls} zoomMeetingUrl={session?.zoomMeetingUrl} options={defaultOptions} />
    );
};
